import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

// Antd
import { Typography, Row, Col, Icon } from "antd";

// Formik
import { FastField, Formik } from "formik";
import moment from "moment";
// Yup
import * as Yup from "yup";

// Component
import Button from "../../../../../../components/Buttons";
import Input from "../../../../../../components/Common/Input";
import typo, { MESSAGE } from "../../../../../../constants/dictionaries";
import Select from "../../../../../../components/Common/Select";
import message from "../../../../../../components/Messages";
import NumberField from "../../../../../../components/Common/NumberField"
import constant from "../../../../../../constants/constant";
import DonViXCPGroup from "../../../../../../components/License/DonViDCPGroup";
// Colors
import colors from "../../../../../../constants/colors";

// Styled components
import DateField from "../../../../../../components/Common/DateField"
import styles from "./Modal.module.scss";
import helper from "../../../../../../helper/helper";
import Helper from "../../../../../../helper/helper"
import Api_tnn from "../../../../../../api/api.tnn";
import Api from "../../../../../../api";
import Api_spatial from "../../../../../../api/api.spatial";
import SongVaLuuVuc from '../../../../../../components/CongTrinh/SongVaLuuVuc';
const { Text } = Typography;
const dateFormat = 'DD/MM/YYYY';
const ControllerForm = styled.div`
  // border: 1px solid #c8ced3;
  border-radius: 5px;
  background: ${colors.white};
`;
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
const ControllerButton = styled.div`
  align-items: flex-end;
  padding-top: 10px;
  text-align: right;
`;
const dataCap = [
  { id: 1, ten: "Trung ương" },
  { id: 2, ten: "Địa phương" },
]
// Validations for add user
const addOrEditSchema = Yup.object().shape({
  tenTram: Yup.string().required(typo.cscore_input_Required),
});


class TramQT_TNN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data_KinhTuyenTruc: [],
      data_tinh: [],
      data_huyen: [],
      data_xa: [],
      data_MuiChieu: [],
      selectTinh: undefined,
      selectHuyen: undefined,
      selectXa: undefined,
      initialValues: {},
      dataGiayPhep: []
    };
  }

  componentDidMount() {
    const { selectedRow, isEdit } = this.props
    this.getApiTinhs();
    this.getApiMuiChieus();
    if (isEdit) {
      selectedRow.idGiayPhep ? this.GetDVXCP_ByidGiayPhep(selectedRow.idGiayPhep) :
        this.setState({
          initialValues: {
            ...selectedRow,
            loai_KTT: selectedRow.loai_KTT ? selectedRow.loai_KTT : constant.CAP_TRIEN_KHAI,
            ten_KTT: selectedRow.ten_KTT ? selectedRow.ten_KTT : constant.KINH_TUYEN_TRUC_TEN,
            kinhTuyenTruc: selectedRow.kinhTuyenTruc ? selectedRow.kinhTuyenTruc : constant.KINH_TUYEN_TRUC,
            maTinh: selectedRow.maTinh ? selectedRow.maTinh : constant.MA_TINH,
            muiChieu: selectedRow.muiChieu ? selectedRow.muiChieu : 3,
            loaiTram: constant.DIEM_QT,
          },
        })

      this.setState({
        selectTinh: selectedRow.maTinh ? selectedRow.maTinh : undefined,
        selectHuyen: selectedRow.maHuyen ? selectedRow.maHuyen : undefined,
        selectXa: selectedRow.maXa ? selectedRow.maXa : undefined,
      })
      this.getApiHuyenByTinhs(selectedRow.maTinh ? selectedRow.maTinh : constant.MA_TINH);
      this.getApiXaByHuyens(selectedRow.maHuyen ? selectedRow.maHuyen : undefined);
      this.GetApidmkinhtuyentrucs(selectedRow.loai_KTT ? selectedRow.loai_KTT : undefined)
    } else {
      selectedRow.id && this.GetDVXCP_ByidGiayPhep(selectedRow.id, "add")
      if (constant.CAP_TRIEN_KHAI === 2) {
        this.getApiHuyenByTinhs(constant.MA_TINH);
        this.GetApidmkinhtuyentrucs(2)
      } else if (constant.CAP_TRIEN_KHAI === 1) {
        this.GetApidmkinhtuyentrucs(1)
      }
    }
  }
  GetDVXCP_ByidGiayPhep = (idgiayphep, mode) => {
    const { user, selectedRow } = this.props;
    new Api_tnn().GetDVXCP_ByidGiayPhep({ token: user.access_token, idgiayphep: idgiayphep })
      .then(res => {
        if (mode === "add") {
          this.setState({
            initialValues: {
              loai_KTT: constant.CAP_TRIEN_KHAI,
              ten_KTT: constant.KINH_TUYEN_TRUC_TEN,
              kinhTuyenTruc: constant.KINH_TUYEN_TRUC,
              maTinh: constant.CAP_TRIEN_KHAI === 2 ? constant.MA_TINH : undefined,
              muiChieu: constant.CAP_TRIEN_KHAI === 1 ? 6 : 3,
              loaiTram: constant.DIEM_QT,
              idDonViXinCapPhep: res.idDonViXinCapPhep,
              tenDonViXCP: res.tenDonViXCP,
              diaChiDonViXCP: res.diaChiDonViXCP,
              soGiayPhep: res.soGiayPhep,
              ngayCapPhep: res.ngayKy
            },
          })
        } else {
          this.setState({
            initialValues: {
              ...selectedRow,
              loai_KTT: selectedRow.loai_KTT ? selectedRow.loai_KTT : constant.CAP_TRIEN_KHAI,
              ten_KTT: selectedRow.ten_KTT ? selectedRow.ten_KTT : constant.KINH_TUYEN_TRUC_TEN,
              kinhTuyenTruc: selectedRow.kinhTuyenTruc ? selectedRow.kinhTuyenTruc : constant.KINH_TUYEN_TRUC,
              idDonViXinCapPhep: res.idDonViXinCapPhep,
              tenDonViXCP: res.tenDonViXCP,
              diaChiDonViXCP: res.diaChiDonViXCP,
              soGiayPhep: res.soGiayPhep,
              ngayCapPhep: res.ngayKy

            },
          })
        }
      })
      .catch((err) => message.error(err.message))
  };

  GetApidmkinhtuyentrucs = (cap) => {
    new Api()
      .Getdmkinhtuyentrucs({ token: this.props.user.access_token, page: "0", size: "0", cap: cap })
      .then(res => { this.setState({ data_KinhTuyenTruc: res.data }); })
      .catch(err => {
        message.error(err.message)
      });
  };
  getApiTinhs = () => {
    new Api()
      .getTinhs({ token: this.props.user.access_token, })
      .then(res => { this.setState({ data_tinh: res }); });
  };
  getApiHuyenByTinhs = (maTinh) => {
    new Api()
      .getHuyenByTinhs({
        token: this.props.user.access_token,
        maTinh: maTinh
      })
      .then(res => { this.setState({ data_huyen: res }) });
  };
  getApiXaByHuyens = (mahuyen) => {
    new Api()
      .getXaByHuyens({
        token: this.props.user.access_token,
        maHuyen: mahuyen
      })
      .then(res => { this.setState({ data_xa: res }) });
  };
  getApiMuiChieus = () => {
    new Api_tnn()
      .GetMuiChieus({ token: this.props.user.access_token, })
      .then(res => { this.setState({ data_MuiChieu: res }); });
  };

  GetCT_GiayPhep_ByIdDVXCP = (iddvxcp) => {
    const { user } = this.props;
    new Api_tnn().GetCT_GiayPhep_ByIdDVXCP({ token: user.access_token, iddvxcp: iddvxcp })
      .then(res => {
        this.setState({ dataGiayPhep: res })
      })
      .catch((err) => message.error(err.message))
  };

  SelectTinh = (value, name) => {
    this.setState({
      data_xa: [],
      selectTinh: value,
    })
    this.getApiHuyenByTinhs(value)
  }

  SelectHuyen = (value, name) => {
    this.setState({
      selectHuyen: value
    })
    this.getApiXaByHuyens(value)
  }
  SelectXa = (value, name) => {
    this.setState({
      selectXa: value
    })
  }
  onSelectLKTT = (value) => {
    this.GetApidmkinhtuyentrucs(value)
  }
  handleGP = (value) => {
    this.GetCT_GiayPhep_ByIdDVXCP(value)
  }
  render() {
    const {
      handleCloseModal,
      selectedRow,
      isEdit,
      handleAdd,
      mode
    } = this.props;
    const { dataGiayPhep, data_xa, data_huyen, data_tinh, selectXa, selectHuyen, selectTinh, data_KinhTuyenTruc, data_MuiChieu, initialValues } = this.state

    return (
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={addOrEditSchema}
          onSubmit={async (values, actions) => {
            var tenDVHCTram = helper.gettenDVHC(data_xa, data_huyen, data_tinh, selectXa, selectHuyen, selectTinh)
            const { degree, minute } = await helper.getKTTById(this.props.user.access_token, values.kinhTuyenTruc);
            if (isEdit) {
              new Api_tnn()
                .PutTNN_BCDK_TramQuanTrac({
                  token: this.props.user.access_token,
                  TramQT_Input: { ...values, tenDVHC: tenDVHCTram },
                  id: selectedRow.id
                })
                .then(res => {
                  if (values.toaDo !== undefined && values.toaDo !== null && values.toaDo !== "") {
                    new Api_spatial()
                      .LuuQuanTracTNNDiem({
                        token: this.props.user.access_token,
                        obj: {
                          toado: values.toaDo,
                          idtramquantrac: values.id,
                          tentram: values.tenTram,
                          diadiem: values.diaDiem,
                          idgiayphep: values.idGiayPhep
                        },
                        ktt_do: degree,
                        ktt_phut: minute,
                        muichieu: values.muiChieu
                      })
                      .then(res => {
                        message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                        actions.resetForm({});
                      })
                      .catch(res => {
                        // message.warning(MESSAGE.CSCORE_TOA_DO_DEM)
                      })
                  } else {
                    message.success(MESSAGE.CSCORE_UPDATE_SUCCESS);
                  }
                  handleAdd();
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
            else {
              new Api_tnn()
                .PostTNN_BCDK_TramQuanTrac({
                  token: this.props.user.access_token,
                  TramQT_Input: { ...values, tenDVHC: tenDVHCTram },
                })
                .then(res => {
                  if (values.toaDo !== undefined && values.toaDo !== null && values.toaDo !== "") {
                    new Api_spatial()
                      .LuuQuanTracTNNDiem({
                        token: this.props.user.access_token,
                        obj: {
                          toado: values.toaDo,
                          idtramquantrac: res.id,
                          tentram: values.tenTram,
                          diadiem: values.diaDiem,
                          idgiayphep: values.idGiayPhep
                        },
                        ktt_do: degree,
                        ktt_phut: minute,
                        muichieu: values.muiChieu
                      })
                      .then(res => {
                        message.success(MESSAGE.CSCORE_ADD_SUCCESS);

                        actions.resetForm({});
                      })
                      .catch(res => {
                        // message.warning(MESSAGE.CSCORE_TOA_DO_DEM)
                      })
                  } else {
                    message.success(MESSAGE.CSCORE_ADD_SUCCESS);
                  }
                  handleAdd();
                })
                .catch(err => {
                  message.error(err.message)
                })
            }
          }}
          render={({
            errors,
            handleSubmit,
            touched,
            dirty,
            values,
            setFieldValue
          }) => (
              <form onSubmit={handleSubmit} autoComplete="false">
                <ControllerForm>
                  <Row>
                    <Col span={12}>
                      <ControllerInput>
                        <DonViXCPGroup
                          values={values}
                          setFieldValue={setFieldValue}
                          mode="edit"
                          handleGP={this.handleGP}
                          view={mode}
                        />
                        <Select
                          placeholder={Helper.genSelectPL(typo.cscore_license_number)}
                          label={typo.cscore_license_number}
                          onChange={(value, name) => {
                            setFieldValue("soGiayPhep", name.props.children);
                            setFieldValue("idGiayPhep", value);
                            setFieldValue("ngayCapPhep", Helper.getFieldValueFromID(value, dataGiayPhep, "ngayKy"));
                          }}
                          dataSource={dataGiayPhep}
                          width="100%"
                          name="soVanBan"
                          name_value="id"
                          defaultValue={values.soGiayPhep}
                          value={values.soGiayPhep}
                          disabled={isEdit ? true : false}
                        />
                        <DateField
                          format={dateFormat}
                          placeholder={Helper.genSelectPL(typo.cscore_ngay_cap_phep)}
                          label={typo.cscore_ngay_cap_phep}
                          onChange={value => { setFieldValue("ngayCapPhep", value && value.format()) }}
                          defaultValue={values.ngayCapPhep}
                          value={values.ngayCapPhep ? moment(values.ngayCapPhep) : null}
                          disabled={true}
                        />
                        <FastField name="soHieu" render={({ field }) => (
                          <Input placeholder={typo.cscore_so_hieu} label={typo.cscore_so_hieu} mandatory={false} {...field} />)} />
                        {touched.soHieu && (<Text type="danger" className={styles.textFont}>{errors.soHieu}</Text>
                        )}

                        <FastField name="tenTram" render={({ field }) => (
                          <Input placeholder={typo.cscore_ten_tram} label={typo.cscore_ten_tram} {...field} />)} />
                        {touched.tenTram && (<Text type="danger" className={styles.textFont}>{errors.tenTram}</Text>
                        )}

                        <FastField name="hangTram" render={({ field }) => (
                          <Input placeholder={typo.cscore_hang_tram} label={typo.cscore_hang_tram} mandatory={false} {...field} />)} />
                        {touched.hangTram && (<Text type="danger" className={styles.textFont}>{errors.hangTram}</Text>
                        )}
                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_province_placeholder)}
                          label={typo.cscore_province}
                          onChange={(value, name) => {
                            setFieldValue("maTinh", value);
                            { setFieldValue("maHuyen", undefined) };
                            { setFieldValue("maXa", undefined) };
                            this.SelectTinh(value, name)
                          }}
                          dataSource={data_tinh}
                          width="100%"
                          name="tenDVHC"
                          name_value="maTinh"
                          value={values.maTinh}
                        />

                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_district_placeholder)}
                          label={typo.cscore_district}
                          onChange={(value, name) => {
                            setFieldValue("maHuyen", value);
                            { setFieldValue("maXa", undefined) };
                            this.SelectHuyen(value, name)
                          }}
                          dataSource={data_huyen}
                          width="100%"
                          name="tenDVHC"
                          name_value="maHuyen"
                          value={values.maHuyen}
                        />

                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_ward_placeholder)}
                          label={typo.cscore_ward}
                          onChange={(value, name) => {
                            setFieldValue("maXa", value);
                            this.SelectXa(value, name)
                          }}
                          dataSource={data_xa}
                          width="100%"
                          name="tenDVHC"
                          name_value="maXa"
                          value={values.maXa}
                        />

                      </ControllerInput>
                    </Col>
                    <Col span={12}>
                      <ControllerInput>
                        <FastField name="diaDiem" render={({ field }) => (
                          <Input placeholder={typo.cscore_hydropower_place} label={typo.cscore_hydropower_place} mandatory={false} {...field} />)} />
                        {touched.diaDiem && (<Text type="danger" className={styles.textFont}>{errors.diaDiem}</Text>
                        )}

                        <FastField name="donViQuanLy" render={({ field }) => (
                          <Input placeholder={typo.cscore_donViQuanLy} label={typo.cscore_donViQuanLy} mandatory={false} {...field} />)} />
                        {touched.donViQuanLy && (<Text type="danger" className={styles.textFont}>{errors.donViQuanLy}</Text>
                        )}
                        <FastField name="toaDo" validate={helper.validateToaDo} render={({ field }) => (<Input mandatory={false} label={typo.cscore_toa_do} {...field} placeholder={typo.cscore_toaDo} />)} />
                        {touched.toaDo && (<Text type="danger">{errors.toaDo}</Text>)}

                        <Select
                          dataSource={dataCap}
                          label={typo.cscore_loaiKTT}
                          defaultValue={values.loai_KTT ? Number(values.loai_KTT) : undefined}
                          onChange={(value) => { setFieldValue("loai_KTT", value); setFieldValue("kinhTuyenTruc", undefined); this.onSelectLKTT(value) }}
                          placeholder={helper.genSelectPL(typo.cscore_chon_cap)}
                          mandatory={false}
                          width="100%"
                          name="ten"
                          name_value="id"
                          value={values.loai_KTT}
                        />
                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_kinh_tuyen_truc)}
                          label={typo.cscore_kinh_tuyen_truc}
                          onChange={(value, name) => { setFieldValue("kinhTuyenTruc", value); setFieldValue("ten_KTT", name.props.children) }}
                          dataSource={this.state.data_KinhTuyenTruc}
                          width="100%"
                          name="ten"
                          name_value="id"
                          defaultValue={values.kinhTuyenTruc}
                          value={values.kinhTuyenTruc}
                        />

                        <Select
                          mandatory={false}
                          placeholder={helper.genSelectPL(typo.cscore_mui_chieu)}
                          label={typo.cscore_mui_chieu}
                          onChange={value => setFieldValue("muiChieu", value)}
                          dataSource={data_MuiChieu}
                          width="100%"
                          name="ten"
                          name_value="id"
                          value={values.muiChieu}
                        />

                        <NumberField
                          label={typo.cscore_namXayDung}
                          placeholder={typo.cscore_namXayDung}
                          mandatory={false} id="namXayDung"
                          min={0}
                          onChange={value => setFieldValue("namXayDung", value)}
                          value={values.namXayDung}
                        />

                        <NumberField
                          label={typo.cscore_namSuDung}
                          placeholder={typo.cscore_namSuDung}
                          mandatory={false} id="namSuDung"
                          min={0}
                          onChange={value => setFieldValue("namSuDung", value)}
                          value={values.namSuDung}
                        />

                        <SongVaLuuVuc
                          values={values}
                          setFieldValue={setFieldValue} />

                      </ControllerInput>
                    </Col>
                  </Row>

                  <ControllerButton>
                    {mode !== 'view' &&
                      <button
                        className="ant-btn"
                        type="submit"
                        disabled={!isEmpty(errors) || !dirty}
                      >
                        <Icon type="save" style={{ marginRight: "8px" }} />
                        {typo.cscore_submit}
                      </button>
                    }
                    <Button
                      type="cancel"
                      className={styles.buttonMargin}
                      onClick={handleCloseModal}
                    >
                      <Icon type="arrow-right" />
                      {typo.cscore_exit}
                    </Button>
                  </ControllerButton>
                </ControllerForm>
              </form>
            )}
        />
      </div>
    );
  }
}

TramQT_TNN.propTypes = {
  handleAddAccount: PropTypes.func.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  isEdit: PropTypes.bool
};

export default TramQT_TNN;
